<div class="fulfillmentLanding container-return-wrapper associate-crop-landing">
  <div class="containerReturnsLandingPage">
    <div class="row">
      <div class="order-view-sec breadcrumbOuter padding-0">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="refreshScreen()">Associate Order</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item">
              <span>Crop Order Reconciliation</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row filtersData">
      <div class="col-lg-11 col-md-9 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (exportClick)="export()" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div>
        <button mat-raised-button class="btns xs-button xs-full-width exportBtn" [disabled]="(associateDataSource && associateDataSource.data.length == 0)" (click)="export()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">
        <mat-tab-group class="matTabs prepayLandingTab">
          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Associate Crop Orders
                </h4>
                <p class="subhead">
                  View Your Associate Crop Orders
                </p>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-sm-4 d-flex align-items-center">
                  <mat-checkbox *ngIf="associateDataSource?.data?.length > 0 && !readOnlyAccess" #AllProductCheck class="custom-checkbox select-check"
                                [checked]="(isAllAccountsChecked) || associateDataSource?.data?.length === checkBoxCount" id="chkSelectAll"
                                [style.display]="disablecheckbox ? 'none' : 'block'"
                                [indeterminate]="checkBoxCount > 0 && checkBoxCount < associateDataSource?.data?.length"
                                (change)="enableAllCheckBoxes(!isAllAccountsChecked)"
                                title="Select All Lines"></mat-checkbox>
                  <div class="product-tools-outer" *ngIf="showTabs">
                    <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">
                      <div class="tab-bar p-0 col-md-10">
                        <ul>
                          <li (click)="showTab('Cancelled')" [ngClass]="{'active': tabNode==='Cancelled'}" class="seperator" matTooltip="Cancel" [matTooltipPosition]="'above'" matTooltipClass='whiteFontCpp'>
                            <i class="trash-icon"></i>
                          </li>
                          <li (click)="showTab('approve')" [ngClass]="{'active': tabNode==='approve'}" class="seperator" matTooltip="Approve" [matTooltipPosition]="'above'" matTooltipClass='whiteFontCpp'>
                            <i class="approve-icon"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #associatePaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table multiTemplateDataRows #associateTable [dataSource]="associateDataSource" matSort #associateSort matSortDirection="desc" class="matTables containerDrafTable">
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef style="padding-left: 6px" class="dsmNo text-center">Edit</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <mat-checkbox #SingleCheck
                                  (change)="enableCheckBoxSingle(SingleCheck.checked,element)"
                                  [(ngModel)]="element.isSelected"
                                  [disabled]="!element.isEditable || readOnlyAccess"
                                  class="custom-checkbox">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="orderHeaderID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Order Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info">
                      <p class="accNo">
                        {{element.orderHeaderID}}
                      </p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="shipToAccount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.shipToAccount}} </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Account</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    <div class="order-info">
                      <p class="accName">
                        {{element.shipToAccount}} - {{element.accountName}}
                      </p>
                      <p class="accName">{{element.shipToCity}}, {{element.shipToState}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="associateName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Associate Location</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    <div class="order-info">
                      <p class="accName">
                        {{element.associateName}},
                      </p>
                      <p class="accName">{{element.associateCity}},{{element.associateState}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="orderDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Requested by Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="brand">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Variety</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.brand}} </td>
                </ng-container>
                <ng-container matColumnDef="orderQty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units text-center">Ordered Qty</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div class="order-qty-controls">
                      <button *ngIf="element.isSelected" (click)="AssociateOrderUnitChange('decrease', element)" class="plus-minus-btn minusBtn">-</button>
                      <input [disabled]="!element.isSelected" type="text" class="geu-txt padding-t2" [(ngModel)]="element.orderQty" (keyup)="quantityTextChange(element)" maxlength="15" appNumbersOnly />
                      <button *ngIf="element.isSelected" (click)="AssociateOrderUnitChange('increase', element)" class="plus-minus-btn plusBtn">+</button>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="orderUOM">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">UOM</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderUOM}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Status</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.status}} </td>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element;" class="p-0" [attr.colspan]="associateOrderColumns.length">
                    <div class="example-element-detail" *ngIf="element.isSelected" >
                      <div class="detail-row-container">
                        <div class="detail-actions-left">
                          <button mat-raised-button class="btns btn-add-variety" data-testid="btn-add-variety" (click)="openAddVarietySliderModel(element)">Add Variety</button>
                          <mat-radio-group class="example-radio-group"
                                           [(ngModel)]="element.approvalStatus"
                                           [name]="'status_' + element.rowId"
                                           aria-label="Approval Status"  *ngIf ="!element.isNewLine" (change)="onRadioChange($event,element)">

                            <mat-radio-button class="custom-radio" value="Cancelled">Cancel</mat-radio-button>
                            <mat-radio-button class="custom-radio" value="Approved">Approve</mat-radio-button>

                          </mat-radio-group>


                        </div>
                        <div class="detail-qty-right">
                          <div class="available-qty-badge">
                            <span class="available-qty-label">Available Qty</span>
                            <span class="available-qty-value">{{element.availableQuantity}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="expandedDetails">
                  <td mat-cell class="p-0" *matCellDef="let element" [attr.colspan]="associateOrderColumns.length">
                    <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                      <div class="row">
                        <div class="col-md-9">
                          <ol class="error-list">
                            <li *ngFor="let err of element.lineErrors.errors">
                              {{err.error}}
                          </ol>
                        </div>
                        <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                          <span>
                            Revert to Previous.
                            <i class="icon-ico-Reply"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="associateOrderColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: associateOrderColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="element && element.isSelected"></tr>
                <ng-container *matRowDef="let element; columns: ['expandedDetail'];">
                  <tr mat-row class="example-detail-row" [class.example-expanded-row]="element && element.isSelected"></tr>
                </ng-container>
                <ng-container *matRowDef="let element; columns: ['expandedDetails'];">
                  <tr mat-row class="example-detail-row" [class.example-expanded-row]="element && element.lineErrors.errors.length > 0"></tr>
                </ng-container>
              </table>
              <div *ngIf="associateDataSource == undefined || (associateDataSource && associateDataSource.data.length == 0)" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>

        </mat-tab-group>
      </div>
      <div class="SeedFulfillBtnSec" *ngIf="showUpdateDiv">
        <div class="row padding-l20">
          <div class="col-md-6">
            <button mat-raised-button [disabled]="isDisableUpdateButton" class="btns" [style.display]="'inline-block'" id="btnReviewRequest" (click) ="addUpdateReconcileOrder()">Update Order</button>
            <button mat-raised-button class="btns" color="primary" (click)="refreshScreen()"  [style.display]="'inline-block'" id="btnSaveDraft">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

